module.exports = __webpack_public_path__ + "assets/fonts/arrow-up-1.3deb56b3.svg";